import { ProblemReport } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function reportProblem(report: ProblemReport): Promise<void> {
  return DesignService.post('support/reportProblem', { data: report });
}
